// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commonTable {

    -ms-overflow-style: none;
    /* IE and Edge */
    scrollbar-width: none;
    /* Firefox */
  
    &::-webkit-scrollbar {
      display: none;
    }
  
    tr {
      background-color: #FFFFFF;
    }
  
    th,
    td {
      min-width: 150px;
  
      &.dd {
        min-width: 250px;
      }
    }
  
    th:last-child, td:last-child {
      min-width: 100px;
    }
  
    th {
      text-align: left;
      white-space: nowrap;
    }
  
    .table-header {
      height: 42px;
      color: #002466;
      font-family: 'Avenir', sans-serif;
      font-size: 14px;
      font-weight: 700;
      line-height: 20px;
      background-color: #E3ECF9;
    }
  
    .sub-header {
      background-color: #EDF5FF;
      text-align: center;
    }
  
    .table-row {
      height: 40px;
      width: fit-content;
      color: #34383F;
  
      &:hover {
        background-color: #F8F9FA;
      }
    }
  
    .fixed {
      position: sticky;
      background-color: inherit;
    }
  
    .fixed.left {
      min-width: 150px;
      left: 0;
    }
  
    .fixed.right {
      min-width: 50px !important;
      right: 0;
    }
  
    .last-updated-width {
      min-width: 200px !important;
    }
  
    .min-w-action {
      width: 100px !important;
    }
  
    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  
    /* Firefox */
    input[type=number] {
      -moz-appearance: textfield;
    }
  }`, "",{"version":3,"sources":["webpack://./src/components/Common/ReactEditableTable/styles.css"],"names":[],"mappings":"AAAA;;IAEI,wBAAwB;IACxB,gBAAgB;IAChB,qBAAqB;IACrB,YAAY;;IAEZ;MACE,aAAa;IACf;;IAEA;MACE,yBAAyB;IAC3B;;IAEA;;MAEE,gBAAgB;;MAEhB;QACE,gBAAgB;MAClB;IACF;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,gBAAgB;MAChB,mBAAmB;IACrB;;IAEA;MACE,YAAY;MACZ,cAAc;MACd,iCAAiC;MACjC,eAAe;MACf,gBAAgB;MAChB,iBAAiB;MACjB,yBAAyB;IAC3B;;IAEA;MACE,yBAAyB;MACzB,kBAAkB;IACpB;;IAEA;MACE,YAAY;MACZ,kBAAkB;MAClB,cAAc;;MAEd;QACE,yBAAyB;MAC3B;IACF;;IAEA;MACE,gBAAgB;MAChB,yBAAyB;IAC3B;;IAEA;MACE,gBAAgB;MAChB,OAAO;IACT;;IAEA;MACE,0BAA0B;MAC1B,QAAQ;IACV;;IAEA;MACE,2BAA2B;IAC7B;;IAEA;MACE,uBAAuB;IACzB;;IAEA,gCAAgC;IAChC;;MAEE,wBAAwB;MACxB,SAAS;IACX;;IAEA,YAAY;IACZ;MACE,0BAA0B;IAC5B;EACF","sourcesContent":[".commonTable {\n\n    -ms-overflow-style: none;\n    /* IE and Edge */\n    scrollbar-width: none;\n    /* Firefox */\n  \n    &::-webkit-scrollbar {\n      display: none;\n    }\n  \n    tr {\n      background-color: #FFFFFF;\n    }\n  \n    th,\n    td {\n      min-width: 150px;\n  \n      &.dd {\n        min-width: 250px;\n      }\n    }\n  \n    th:last-child, td:last-child {\n      min-width: 100px;\n    }\n  \n    th {\n      text-align: left;\n      white-space: nowrap;\n    }\n  \n    .table-header {\n      height: 42px;\n      color: #002466;\n      font-family: 'Avenir', sans-serif;\n      font-size: 14px;\n      font-weight: 700;\n      line-height: 20px;\n      background-color: #E3ECF9;\n    }\n  \n    .sub-header {\n      background-color: #EDF5FF;\n      text-align: center;\n    }\n  \n    .table-row {\n      height: 40px;\n      width: fit-content;\n      color: #34383F;\n  \n      &:hover {\n        background-color: #F8F9FA;\n      }\n    }\n  \n    .fixed {\n      position: sticky;\n      background-color: inherit;\n    }\n  \n    .fixed.left {\n      min-width: 150px;\n      left: 0;\n    }\n  \n    .fixed.right {\n      min-width: 50px !important;\n      right: 0;\n    }\n  \n    .last-updated-width {\n      min-width: 200px !important;\n    }\n  \n    .min-w-action {\n      width: 100px !important;\n    }\n  \n    /* Chrome, Safari, Edge, Opera */\n    input::-webkit-outer-spin-button,\n    input::-webkit-inner-spin-button {\n      -webkit-appearance: none;\n      margin: 0;\n    }\n  \n    /* Firefox */\n    input[type=number] {\n      -moz-appearance: textfield;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
